import { useTranslation as useReactTranslation } from "react-i18next";

import type { TranslationKey } from "./type";

type TranslationParams = Record<string, string | number>;

export function useTranslation() {
  const { i18n, t: translate } = useReactTranslation();

  return {
    locale: i18n.language,
    t: (key: TranslationKey, params?: TranslationParams) =>
      String(translate(key, params)),
  };
}
